module.exports = __webpack_public_path__ + "img/dapp.dac7d816.png";